import React from "react";
import {
  Container,
  Wrapper,
  FormWrapper,
  FormTitle,
  FormInfo,
  DribbleContainer,
  DribbleText,
  Title,
  Text,
  StyledButton,
} from "./styles";
import { Form } from "components/Form";
import { CASES_IFRAME_NAME } from "components/Form/form";

export const ContactForm = () => {
  return (
    <Container id="contact-form">
      <Wrapper>
        <FormWrapper>
          <FormTitle>Chcesz wycenić podobny projekt? Napisz do nas!</FormTitle>
          <Form
            src={process.env.GATSBY_CASE_FORM_URL}
            name={CASES_IFRAME_NAME}
          />

          <FormInfo>Odezwiemy się do 24h.</FormInfo>
        </FormWrapper>
        <DribbleContainer>
          <DribbleText>
            <Title>Zobacz więcej naszych realizacji</Title>
            <Text>Odwiedź już teraz nasz profil na Dribbble.com</Text>
          </DribbleText>
          <StyledButton
            href="https://dribbble.com/intervi"
            target="_blank"
            rel="noopener"
          >
            Zobacz
          </StyledButton>
        </DribbleContainer>
      </Wrapper>
    </Container>
  );
};
